import React from 'react'

export interface IconPersonSilhouetteProps {
    className?: string
}

export const IconPersonSilhouette: React.FC<IconPersonSilhouetteProps> = ({
    className,
}) => (
    <svg
        width="35"
        height="35"
        viewBox="0 0 35 35"
        className={className}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M24.3496 12.917C24.3496 14.6078 23.678 16.2293 22.4824 17.4248C21.2869 18.6204 19.6654 19.292 17.9746 19.292C16.2839 19.292 14.6623 18.6204 13.4668 17.4248C12.2713 16.2293 11.5996 14.6078 11.5996 12.917C11.5996 11.2263 12.2713 9.60476 13.4668 8.40922C14.6623 7.21367 16.2839 6.54202 17.9746 6.54202C19.6654 6.54202 21.2869 7.21367 22.4824 8.40922C23.678 9.60476 24.3496 11.2263 24.3496 12.917V12.917Z"
            fill="#74787A"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0.974609 17.167C0.974609 12.6583 2.76568 8.33433 5.95379 5.14621C9.14191 1.95809 13.4659 0.167023 17.9746 0.167023C22.4833 0.167023 26.8073 1.95809 29.9954 5.14621C33.1835 8.33433 34.9746 12.6583 34.9746 17.167C34.9746 21.6757 33.1835 25.9997 29.9954 29.1878C26.8073 32.376 22.4833 34.167 17.9746 34.167C13.4659 34.167 9.14191 32.376 5.95379 29.1878C2.76568 25.9997 0.974609 21.6757 0.974609 17.167V17.167ZM17.9746 2.29202C15.1734 2.29217 12.4291 3.08329 10.0577 4.57433C7.68629 6.06537 5.78409 8.19572 4.57003 10.7202C3.35598 13.2446 2.87943 16.0606 3.19523 18.844C3.51103 21.6273 4.60635 24.265 6.35511 26.4533C7.86386 24.0223 11.1852 21.417 17.9746 21.417C24.764 21.417 28.0832 24.0201 29.5941 26.4533C31.3429 24.265 32.4382 21.6273 32.754 18.844C33.0698 16.0606 32.5932 13.2446 31.3792 10.7202C30.1651 8.19572 28.2629 6.06537 25.8915 4.57433C23.5201 3.08329 20.7758 2.29217 17.9746 2.29202V2.29202Z"
            fill="#74787A"
        />
    </svg>
)
IconPersonSilhouette.displayName = 'IconPersonSilhouette'
